import UnderConstruction from "../common/UnderConstruction";

export default function InventoryStock() {
  return <UnderConstruction title="Stock Update" />;
}
